import React from 'react';
import NavMenu from './NavMenu';

const Header = () => (
    <header id="header" className="fixed-top">
        <NavMenu />
    </header>
);

export default Header;